module.exports = __webpack_public_path__ + "assets/img/a6a915fe1d8d9f687a4ae376c505a8dd.png";